<template>
    <custom-search
        :label="label"
        :display-value="displayName"
        :disabled="!enabled"
        placeholder="Nombre o celular"
        :fetch-items="searchCustomersByKeyword"
        @select="onSelect"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    >
        <template #item="{ item }">
            <span class="flex items-center justify-between">
                <span
                    >{{ item.firstName | cut(20) }}
                    {{ item.lastName | cut(20) }}</span
                >
                <span
                    v-if="item.phone"
                    class="text-xs text-theme-muted font-mono"
                >
                    {{ item.phone }}
                </span>
            </span>
        </template>
    </custom-search>
</template>

<script>
import { mapActions } from "vuex";

import CustomSearch from "@/components/utils/CustomSearch.vue";

export default {
    name: "CustomersSearch",
    components: {
        CustomSearch
    },
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        defaultFilters: {
            default: () => ({}),
            type: Object,
            required: false
        },
        itemCurrent: {
            default: () => ({ id: "", firstName: "", lastName: "", phone: "" }),
            type: Object,
            required: false
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["blur", "focus", "input"],
    computed: {
        displayName() {
            return `${this.itemCurrent.firstName} ${this.itemCurrent.lastName}`.trim();
        }
    },
    methods: {
        ...mapActions("customers", ["searchCustomers"]),
        searchCustomersByKeyword(keyword) {
            return this.searchCustomers({
                ...this.defaultFilters,
                fullNameOrPhone: keyword
            });
        },
        onSelect(item) {
            this.$emit("input", item);
        }
    }
};
</script>
